import { Typography } from 'shared/components/Typography';

const OptionalText = () => (
  <Typography as="span" color="gray" fontWeight="regular" type="small">
    Optional
  </Typography>
);

export default OptionalText;
